/**
 * created by lei lei
 *编辑器使用demo
 */
import React, {Component} from 'react';
import PropTypes from 'prop-types';

export default class EditorUseDemo extends Component {
    static defaultProps = {};
    static propTypes = {};

    constructor(props) {
        super(props);
        this.state = {
            status:false
        }
    }

    componentWillMount() {
    }

    componentDidMount() {
        window.ueditor.editRefresh = function () {
            console.log('刷新了父页面');
            this.setState({status: true})
        }
    }

    render() {
        return (
            <div onClick={()=>{
                this.openEdit()
            }}>
                打开编辑器   刷新{this.state.status?'了':'没？'}
            </div>
        )
    }
    openEdit(){
        window.openEditById(0)
    }

}